var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 3,
    viewBox: "0 0 22 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V2H21",
    stroke: "#DBE8F3",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/Dash.c9abec5f9f6b43c119d3e5bf8951ad60.svg";
export { ForwardRef as ReactComponent };